export default function _browserScrollbarFix() {
    /* // navigator = new Navigator();
    let OSName = 'Unknown OS';
    if (window.navigator.appVersion.indexOf('Win') !== -1) OSName = 'Windows';
    if (window.navigator.appVersion.indexOf('Mac') !== -1) OSName = 'MacOS';
    if (window.navigator.appVersion.indexOf('X11') !== -1) OSName = 'UNIX';
    if (window.navigator.appVersion.indexOf('Linux') !== -1) OSName = 'Linux';

    console.log(`Your OS: ${OSName}`);
    if (OSName === 'Windows') {
        const { body } = document;
        body.classList.add('windowsOS');
    } */

    // this is a better way to do it as it dynamically grabs the width
    document.body.style.setProperty(
        '--scrollbar-width',
        `${window.innerWidth - document.body.clientWidth}px`
    );
}
